'use client'
import React, { useLayoutEffect, useMemo, useState } from 'react'
import HeaderClient from './Component.client'

const HeaderObserverWrapper = (props: any) => {
  const [scroll, setScroll] = useState<any>()
  // const [isLayout, setIsLayout] = useState<any>()

  useLayoutEffect(() => {
    // const layoutBlocks = document.querySelectorAll('.layout')
    document.addEventListener('scroll', () => {
      const scrollCheck = window.scrollY > 100
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck)
      }
    })

    // if (!layoutBlocks.length) return

    // const handleIntersect = (entries: any[]) => {
    //   // Hide TopBar if any layout block is visible
    //   setIsLayout(entries.some((entry) => entry.isIntersecting))
    // }

    // const observer = new window.IntersectionObserver(handleIntersect, {
    //   root: null,
    //   // threshold: 0.1,
    // })

    // layoutBlocks.forEach((block) => observer.observe(block))

    // return () => {
    //   layoutBlocks.forEach((block) => observer.unobserve(block))
    //   observer.disconnect()
    // }
  }, [])

  const hideTopBar = useMemo(() => {
    return scroll
  }, [scroll])

  return <HeaderClient data={props} hideTopBar={hideTopBar} />
}

export default HeaderObserverWrapper
